import { useMemo } from "react";

import DerailmentMatrix from "../DerailmentMatrix";
import buildDerailmentMatrixData from "../builders/buildDerailmentMatrixData";

export default function DerailmentSection({
    descarrilamentoMonitor
}) {

    const matrixData = useMemo(
        () => buildDerailmentMatrixData(descarrilamentoMonitor),
        [descarrilamentoMonitor]
    );

    return (
        <DerailmentMatrix
            cars={[1, 2, 3, 4, 5, 6, 7, 8]}
            categoryLabel="Descarrilamento"
            rows={[
                {
                    label: "Sensor atuado",
                    key: "sensorAtuado"
                },
                {
                    label: "Sensor em falha",
                    key: "sensorFalha"
                }
            ]}
            matrixData={matrixData}
        />
    );
}